// extracted by mini-css-extract-plugin
export default {"container":"PositionsTable_container__ujh4L","header":"PositionsTable_header__wOpKz","buttons":"PositionsTable_buttons__4v-Xs"};